import * as z from 'zod';

import { PaymentCadenceEnum, TaxEscrowType } from '../../../loan/EscrowSetting';
import { Checkbox, DateString, NonNegativeInteger, NonNegativeMonetaryValue } from '../../fields';

export const TAX_ITEM_COUNT = 3;
export const TAX_ITEM_INDEXES = [1, 2, 3] as const;
export type TaxItemIndex = (typeof TAX_ITEM_INDEXES)[number];

// Accept both the canonical enum value (e.g. "COUNTY_TAX") and the short form
// surfaced by the public REST API ("county"). Case-insensitive on both forms.
export const TaxEscrowTypeCoerced = z.preprocess((val) => {
  if (typeof val !== 'string') return val;
  const upper = val.trim().toUpperCase();
  if (upper.endsWith('_TAX')) return upper;
  return `${upper}_TAX`;
}, TaxEscrowType);

export const taxItemKeys = <N extends TaxItemIndex>(n: N) =>
  ({
    apn: `tax${n}Apn` as const,
    type: `tax${n}Type` as const,
    isEscrowed: `tax${n}IsEscrowed` as const,
    nextPaymentAmount: `tax${n}NextPaymentAmount` as const,
    payeeId: `tax${n}PayeeId` as const,
    payeeName: `tax${n}PayeeName` as const,
    nextDueDate: `tax${n}NextDueDate` as const,
    paymentCadence: `tax${n}PaymentCadence` as const,
    contractNumber: `tax${n}ContractNumber` as const,
    propertyIndex: `tax${n}PropertyIndex` as const,
    countyName: `tax${n}CountyName` as const,
  }) as const;

export const TaxFields = z.object({
  tax1Apn: z.string().optional(),
  tax1Type: TaxEscrowTypeCoerced.optional(),
  tax1IsEscrowed: Checkbox.optional(),
  tax1NextPaymentAmount: NonNegativeMonetaryValue.optional(),
  tax1PayeeId: z.string().optional(),
  tax1PayeeName: z.string().optional(),
  tax1NextDueDate: DateString.optional(),
  tax1PaymentCadence: PaymentCadenceEnum.optional(),
  tax1ContractNumber: z.string().optional(),
  tax1PropertyIndex: NonNegativeInteger.optional(),
  tax1CountyName: z.string().optional(),

  tax2Apn: z.string().optional(),
  tax2Type: TaxEscrowTypeCoerced.optional(),
  tax2IsEscrowed: Checkbox.optional(),
  tax2NextPaymentAmount: NonNegativeMonetaryValue.optional(),
  tax2PayeeId: z.string().optional(),
  tax2PayeeName: z.string().optional(),
  tax2NextDueDate: DateString.optional(),
  tax2PaymentCadence: PaymentCadenceEnum.optional(),
  tax2ContractNumber: z.string().optional(),
  tax2PropertyIndex: NonNegativeInteger.optional(),
  tax2CountyName: z.string().optional(),

  tax3Apn: z.string().optional(),
  tax3Type: TaxEscrowTypeCoerced.optional(),
  tax3IsEscrowed: Checkbox.optional(),
  tax3NextPaymentAmount: NonNegativeMonetaryValue.optional(),
  tax3PayeeId: z.string().optional(),
  tax3PayeeName: z.string().optional(),
  tax3NextDueDate: DateString.optional(),
  tax3PaymentCadence: PaymentCadenceEnum.optional(),
  tax3ContractNumber: z.string().optional(),
  tax3PropertyIndex: NonNegativeInteger.optional(),
  tax3CountyName: z.string().optional(),
});
export type TaxFields = z.infer<typeof TaxFields>;
